import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from "./../../Header";
import CustomerTabMenu from "./CustomerTabMenu";
import DatePicker from "react-datepicker";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import $ from "jquery";
import moment from "moment";
import * as actionFunction from "../../actions/common";
class CustomerList extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem("encdata"), 0) : "";
		this.state = {
			customers: [],
			apiUrl: this.decryptconfigdata("apiUrl"),
			studioUrl: this.decryptconfigdata("studioUrl"),
			activePage: 1,
			item_count: "",
			from_date: "",
			to_date: "",
			search: "",
			startDate: new Date(),
			minDate: new Date(),
			customer_name_muvi6: "",
			studio_id: "",
			user_id: "",
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			isLoadMore: 1,
			Loading: 1,
			showMenu: false,
			allmuvisix: [],
			muvisixproductkey: "3D28C83C85544F0D9517DD2E7C7EEDAA",
			showMenu: false,
			offset: 0,
			muviCountAll: [],
			muviFiveCount: null,
			allMuviAccountManager: [],
			allEmployee: [],
			mssg: [],
			account_manager: [],
			errors: {},
			item_name: "",
			item_description: "",
			invoice_amount: "",
			message: "",
			isMuviOne: false,
			enterprise_api_gateway_url: "",
			isStremInfo: false,
			isMuviLive: false,
			selected_product_key: null,
			customer_success_permission: localStorage.getItem("customer_success_permission"),
			store_permission: localStorage.getItem("store_permission"),
			is_general_user: localStorage.getItem("is_general_user"),
		};
		this.onChange = this.onChange.bind(this);
		this.getCustomers = this.getCustomers.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.formdateChange = this.formdateChange.bind(this);
		this.todateChange = this.todateChange.bind(this);
		this.keywordChange = this.keywordChange.bind(this);
		this.handleChangeStart = this.handleChangeStart.bind(this);
	}
	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
		var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv,
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}
	onChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	goToCustomerStore(email, password, studio_id, studio_name) {
		if (window.confirm("Are you sure to login this store '" + studio_name + "' ?")) {
			var win = window.open(
				this.state.studioUrl +
					"/login/storeLogin" +
					"?email=" +
					email +
					"&password=" +
					password +
					"&studio_id=" +
					studio_id,
				"_blank"
			);
			win.focus();
		}
	}
	formdateChange(event) {
		this.setState({ from_date: event }, function () {
			this.getCustomers();
		});
	}
	todateChange(event) {
		this.setState({ to_date: event }, function () {
			this.getCustomers();
		});
	}
	keywordChange(event) {
		var obj = this;
		this.setState({
			search: event.target.value,
			activePage: 1,
			customers: [],
			Loading: 1,
		});
		//Delaying the function execute
		//Delaying the function execute
		if (this.timer) {
			window.clearTimeout(this.timer);
		}
		if (obj.state.muvisixproductkey != "") {
			this.timer = window.setTimeout(() => {
				obj.muvisixCustomerSearchHandler();
			}, 500);
		} else {
			this.timer = window.setTimeout(function () {
				//Execute the function code here...
				obj.getCustomers();
			}, 500);
		}
	}

	muvisixCustomerSearchHandler = () => {
		this.setState(
			{
				Loading: 1,
			},
			() => {
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${this.state.muvisixproductkey}", type: \"All\", page: 0, size: 20, search : \"${this.state.search}") {page_info{total_count}, user_details {username, name, email, mobile,  created_date,  company_name, country_name, ip_address, address, product_name, user_uuid, user_status, profile_image_url, deleted_date,app_token,onhold_period, canceled_date, cancellation_reason, canceled_by,   domain_name, custom_cancellation_reason, created_date, free_trial_expiry_date,    package_name, package_summary, package_period,account_status, source, store_key, is_enterprise , enterprise_api_gateway_url}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((data) => {
						this.setState({
							customers: data.data.getCustomerList.user_details,
							item_count: data.data.getCustomerList.page_info.total_count,
							Loading: 0,
						});
					});
			}
		);
	};

	handlePageChange(pageNumber = 1) {
		if (this.state.muvisixproductkey != "") {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					dataType: "json",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${
							this.state.muvisixproductkey
						}", type: \"All\", page: ${pageNumber - 1}, size: 20, search : \"${
							this.state.search
						}") {page_info{total_count}, user_details {username, name, email, mobile,  created_date,account_status, company_name, country_name, ip_address, address, product_name,    user_uuid, user_status, profile_image_url, deleted_date, app_token, onhold_period,    canceled_date, cancellation_reason, canceled_by, domain_name custom_cancellation_reason, created_date, free_trial_expiry_date, package_name, package_summary, package_period,account_status, source, store_key, domain_name, is_enterprise , enterprise_api_gateway_url}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((findresponse) => {
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.data.getCustomerList.user_details,
							item_count: findresponse.data.getCustomerList.page_info.total_count,
							//                    offset: findresponse.data.getCustomerList.offset,
							loading: 0,
							activePage: pageNumber,
							setPage: "yes",
						});
					});
			}
		} else {
			var totalPages = Math.ceil(this.state.item_count / 20);
			if (this.state.activePage != pageNumber) {
				$(document).ready(function () {
					$(".pages").addClass("disabled");
				});
				this.setState({ activePage: pageNumber, setPage: "no" });
				fetch(
					this.state.apiUrl +
						"/adminRest/GetallStores/page/" +
						pageNumber +
						"/userId/" +
						this.state.userId +
						"/userAuthKey/" +
						this.state.userAuthKey,
					{
						method: "POST",
						dataType: "json",
						body: JSON.stringify(this.state),
					}
				)
					.then((Response) => Response.json())
					.then((findresponse) => {
						findresponse = this.rawjsonparse(findresponse, 1);
						$(document).ready(function () {
							$(".pages").removeClass("disabled");
							if (pageNumber == 1) {
								$(".first_page").addClass("disabled");
								$(".prev_page").addClass("disabled");
							}
							if (pageNumber == totalPages) {
								$(".next_page").addClass("disabled");
								$(".last_page").addClass("disabled");
							}
						});
						this.setState({
							customers: findresponse.customers,
							offset: findresponse.offset,
							off_count: findresponse.off_count,
							setPage: "yes",
						});
					});
			}
		}
	}

	getCustomers(page = 1) {
		fetch(
			this.state.apiUrl +
				"/adminRest/GetallStores/page/" +
				page +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					customers: findresponse.customers,
					item_count: findresponse.item_count,
					muviFiveCount: findresponse.item_count,
					store_permission: findresponse.store_permission,
					customer_success_permission: findresponse.customer_success_permission,
					is_general_user: findresponse.is_general_user,
					Loading: 0,
					offset: findresponse.offset,
					off_count: findresponse.off_count,
					setPage: "yes",
					muvisixproductkey: "",
				});
			});
	}

	// stream info
	getLiveStreamBtn = (prod_key) => {
		this.setState({ isStremInfo: true });
		this.setState({ showMenu: false });
		this.getStreamInfo(prod_key);
	};

	getStreamInfo(prod_key) {
		var commonStateData = actionFunction.commonData();
		this.setState({ loading: 1 });

		fetch(commonStateData.apiUrl + "/adminRest/getLiveStreamInfo/userAuthKey/" + commonStateData.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify({
				key: prod_key,
			}),
		})
			.then((data) => data.json())
			.then((resp) => {
				this.setState({ streamInfo: resp, loading: 0 });
			});
	}

	stopLiveStream(uuid, product_key) {
		var commonStateData = actionFunction.commonData();
		this.setState({ loading: 1 });
		fetch(commonStateData.apiUrl + "/adminRest/stopLiveStream/userAuthKey/" + commonStateData.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify({
				livestream_uuid: uuid,
				product_key: product_key,
			}),
		})
			.then((data) => data.json())
			.then((findresponse) => {
				if (findresponse.code == 200) {
					this.getStreamInfo(product_key);
				} else if (findresponse.code == 400) {
					this.getStreamInfo(product_key);
				} else {
					this.setState({ loading: 0 });
				}
			});
	}

	getStopStreamBtn(id, product_key, user_uuid, username) {
		return this.state.showMenu ? (
			<ul class="onclick-menu-content">
				<li onClick={() => this.userDataEncrypt(product_key, user_uuid, username)}>
					<a>Log-In to Account</a>
				</li>

				{this.state.store_permission == 1 || this.state.customer_success_permission == 1 ? (
					<li onClick={() => this.stopLiveStream(id, product_key)}>
						<a>Stop Stream</a>
					</li>
				) : (
					""
				)}
			</ul>
		) : (
			""
		);
	}

	convertHMS(value) {
		const sec = parseInt(value, 10);
		let hours = Math.floor(sec / 3600);
		let minutes = Math.floor((sec - hours * 3600) / 60);
		let seconds = sec - hours * 3600 - minutes * 60;

		if (hours < 10) {
			hours = "0" + hours;
		}
		if (minutes < 10) {
			minutes = "0" + minutes;
		}
		if (seconds < 10) {
			seconds = "0" + seconds;
		}
		return hours + " Hrs " + minutes + " minutes";
	}

	liveStreamList() {
		return (
			<div class="list_check">
				<div class="tickets hidden-sm">
					<ul class="tickets_head">
						<li class="intra_col_15">Company</li>
						<li class="intra_col_15">Name</li>
						<li class="intra_col_20">Start Time</li>
						<li class="intra_col_20">Duration</li>
						<li class="intra_col_20">Instance ID</li>
						<li class="intra_col_2"></li>
					</ul>
					{this.state.loading == 1 ? (
						<div>
							<div class="loader-new"></div>
						</div>
					) : this.state.streamInfo.code != 400 ? (
						this.state.streamInfo.data.map((item, i) => {
							return (
								<ul class="tickets_number" key={i}>
									<li class="intra_col_15 text-inded">
										<Link to={`/test/detail/${item.app_token}`} target="_blank">
											{" "}
											{item.company ? item.company : "NA"}
										</Link>
									</li>
									<li class="intra_col_15 text-inded">{item.name}</li>
									<li class="intra_col_20 text-inded"> {item.start_time} </li>
									<li class="intra_col_20 text-inded"> {this.convertHMS(item.duration)} </li>
									<li class="intra_col_20 text-inded"> {item.instance_id} </li>

									<li
										onClick={this.menuHideShow}
										style={{ position: "relative" }}
										className="intra_col_2"
									>
										<div tabindex="0" class="onclick-menu c-details pull-right">
											<i class="fa fa-ellipsis-v" aria-hidden="true"></i>
											{this.getStopStreamBtn(
												item.livestream_uuid,
												item.product_key,
												item.user_uuid,
												item.username
											)}
										</div>
									</li>
								</ul>
							);
						})
					) : (
						<span>
							<div className="text-center" style={{ color: "#333", marginTop: "15px" }}>
								No Data Found
							</div>
						</span>
					)}
				</div>
			</div>
		);
	}
	// End stream info

	getMuvisixCustomer = (event, cond = 0) => {
		if (cond == 1) {
			var prod_key = event.target;
		} else {
			const { value } = event.target;
			var prod_key = value;
		}
		this.setState({ isMuviOne: false });
		if (prod_key !== "") {
			if (prod_key == "3D28C83C85544F0D9517DD2E7C7EEDAA") {
				this.setState({ isMuviOne: true });
			}

			if (prod_key == "8E4F8A19B07D4F22927CD4CB54672D20" || prod_key == "7718F46772A54819AE19147BCE9D3D6B") {
				this.setState({ isMuviLive: true, selected_product_key: prod_key, isStremInfo: false });
			} else {
				this.setState({ isMuviLive: false, isStremInfo: false });
			}

			this.setState(
				{
					Loading: 1,
					search: "",
				},
				() => {
					this.getCustomersforSearch();
					fetch("https://apigateway.muvi.com/customer-list", {
						method: "POST",
						dataType: "json",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							query: `{getCustomerList( product_key: "${prod_key}", type: \"All\", page: 0, size: 20) {page_info{total_count}, user_details {username, name, email, company_name, account_status, country_name, product_name, user_uuid, user_status, app_token,created_date, onhold_period, canceled_date, cancellation_reason, canceled_by,package_name, package_summary,  plan_name, source, store_key, domain_name, is_enterprise , enterprise_api_gateway_url}}}`,
						}),
					})
						.then((Response) => Response.json())
						.then((findresponse) => {
							this.setState({
								Loading: 0,
								customers: findresponse.data.getCustomerList.user_details,
								item_count: findresponse.data.getCustomerList.page_info.total_count,
								//                        offset: findresponse.data.getCustomerList.offset,
								activePage: 1,
								setPage: "yes",
							});
						});
					this.setState({
						muvisixproductkey: prod_key,
					});
				}
			);
		} else {
			this.setState(
				{
					customerByproductName: [],
					search: "",
				},
				() => {
					this.getCustomers(1);
				}
			);
		}
	};

	getCustomersforSearch = (page = 1) => {
		fetch(
			this.state.apiUrl +
				"/adminRest/GetallStores/page/" +
				page +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					muviFiveCount: findresponse.item_count,
				});
			});
	};

	userDataEncrypt = async (productkey, userid, uname) => {
		const REDIRECT_URL = `https://account.muvi.com`;
		if (window.confirm(`Are you sure to login this store ${uname}`)) {
			const loginDetails = {
				product_key: `${productkey}`,
				user_uuid: `${userid}`,
				muvi_user_uuid: "17325ad1c482fa796bfbea34d7157",
			};
			const response = await fetch(
				this.state.apiUrl + "/adminRest/encData/userAuthKey/" + this.state.userAuthKey,
				{
					method: "POST",
					body: JSON.stringify(loginDetails),
				}
			);

			const user_data = await response.json();

			this.setState(
				{
					user_data,
					showMenu: false,
					isLoadMore: 0,
				},
				async () => {
					try {
						const loginRespnse = await fetch(`${this.state.apiUrl}/AdvancedRest/getintraLogin`, {
							method: "POST",
							// headers: {
							//     "content-type": 'application/json'
							// },
							body: JSON.stringify(this.state.user_data),
						});

						const loginRes = await loginRespnse.json();
						const responseLogin = await JSON.parse(loginRes);
						const { data, response, status } = responseLogin;
						if (status === "SUCCESS") {
							window.open(
								`${REDIRECT_URL}/autologin?continue=${data.product_cms_full_url}&token=${response.refresh_token}`,
								"_blank"
							);
							//                    window.open(`${data.urlEndPoint}`, '_blank');
						}
					} catch (error) {
						console.log(error);
					}
				}
			);
		}
	};
	rawjsonparse(findresponse, flg) {
		return findresponse;
	}

	export() {
		var win = window.open(
			this.state.apiUrl +
				"/AdminRest/ExportUsers/userAuthKey/" +
				this.state.userAuthKey +
				"/user_type/all/search/" +
				this.state.search,
			"_self"
		);
		win.focus();
	}

	// ER #75420: Permissions for Log In to Account, if General user, hide 3 dots as no CTA is there
	getMuvi5TypeStatus(status) {
		if (status === "Lead") {
			if (this.state.is_general_user != 1) {
				return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
			} else {
				return "";
			}
		} else if (status === "Paying") {
			if (this.state.is_general_user != 1) {
				return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
			} else {
				return "";
			}
		} else if (status === "Cancelled") {
			return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
		} else if (status === "Deleted") {
			return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
		} else if (status === "Demo") {
			if (this.state.is_general_user != 1) {
				return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
			} else {
				return "";
			}
		}
	}

	getMuvi6TypeStatus(status) {
		if (status === "lead") {
			if (this.state.is_general_user != 1) {
				return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
			} else {
				return "";
			}
		} else if (status === "customer") {
			return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
		} else if (status === "cancel") {
			return "";
		} else if (status === "delete") {
			return "";
		} else if (status === "demo") {
			if (this.state.is_general_user != 1) {
				return <i class="fa fa-ellipsis-v" aria-hidden="true"></i>;
			} else {
				return "";
			}
		}
	}

	gettype(is_subscribed, status, deleted, is_default, muvi_free) {
		if (is_subscribed == 0 && status == 1 && deleted == 0 && is_default == 0 && muvi_free == 0) {
			return "Lead";
		} else if (is_subscribed == 1 && status == 1 && deleted == 0 && is_default == 0 && muvi_free == 0) {
			return "Paying";
		} else if (is_subscribed == 1 && status == 1 && deleted == 0 && is_default == 0 && muvi_free == 1) {
			return "Muvi Free";
		} else if (is_subscribed == 0 && status == 4 && deleted == 0 && is_default == 0) {
			return "Cancelled";
		} else if (is_subscribed == 0 && status == 0 && deleted == 1 && is_default == 0) {
			return "Deleted";
		} else if (status == 1 && is_default == 1) {
			return "Demo";
		} else if (status == 0 && is_subscribed == 0) {
			return (
				<div>
					<span>s zero not subscribed</span>
				</div>
			);
		} else if (status == 2 && is_subscribed == 0) {
			return (
				<div>
					<span>incomplete</span>
				</div>
			);
		}
	}

	customer_details(studio_id, studio_name, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/customerdetails/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				this.setState({
					studio_id: findresponse.studio_id,
					user_id: findresponse.user_id,
					check_account_manager: findresponse.check_account_manager ? findresponse.check_account_manager : "",
					account_manager: findresponse.account_manager,
					studio_id_id: findresponse.studio_id.id,
					user_id_id: findresponse.user_id.id,
					studio_id_name: findresponse.studio_id.name,
					id: findresponse.id ? findresponse.id : "",
				});
				if (this.state.studio_id.start_date != "0000-00-00") {
					let x = new Date(this.state.studio_id.start_date);
					this.setState({ startDate: x });
				}
			});
	}

	Savepassword(studio_id, user_id, pwd) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/Savepassword/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/new_password/" +
				pwd +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({ message: findresponse.msg }, function () {
						window.location.href = "/allStores";
					});
				} else {
					this.setState({ message: findresponse.msg });
				}
			});
	}

	getSourceLink(link) {
		if (link) {
			if (link.indexOf("http") !== -1) {
				var linknew = <a href={`${link}`} target="_blank">{`${link}`}</a>;
				return linknew;
			} else {
				return link;
			}
		} else {
			let na = "NA";
			return na;
		}
	}
	movetoDemo(studio_id, studio_name, user_id) {
		if (window.confirm("Are you sure you want to move '" + studio_name + "' account to demo studio?")) {
			fetch(
				this.state.apiUrl + "/adminRest/movetoDemo/id/" + studio_id + "/userAuthKey/" + this.state.userAuthKey,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					if (findresponse.code == 200) {
						this.setState({ message: findresponse.msg });
					} else {
						this.setState({ message: findresponse.msg });
					}
					this.getCustomers();
					this.setState({});
				});
		}
	}

	leadMovetoDemo = async (productKey, appToken, moveToDemo, userId, username, name, storeKey) => {
		if (window.confirm("Are you sure you want to move '" + name + "' account to demo studio?")) {
			this.setState({
				menusOpen: false,
				showMenu: false,
			});
			fetch("https://apigateway.muvi.com/accounts/manage-demo-account", {
				method: "POST",
				headers: { "content-type": "application/json" },
				body: JSON.stringify({
					product_key: productKey,
					app_token: appToken,
					is_demo: moveToDemo,
					user_uuid: userId,
					store_key: storeKey,
				}),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.fetchProductByKey(productKey);
				});
		}
	};

	getCustomersMenu(
		studio_id,
		studio_name,
		user_id,
		email,
		encrypted_password,
		name,
		is_subscribed,
		status,
		deleted,
		is_default,
		account_manager,
		company_name = null,
		account_status = null,
		storeKey = null,
		productkey = null,
		apptoken = null,
		leadToDemo = null,
		useruid = null,
		uname = null,
		muvi_free = null,
		is_enterprise = false,
		enterprise_api_gateway_url = ""
	) {
		var get_enterprise_api_gateway_url = "";
		if (is_enterprise) {
			var get_enterprise_api_gateway_url = enterprise_api_gateway_url;
		}
		if (
			(is_subscribed == 0 && status == 1 && deleted == 0 && is_default == 0 && muvi_free == 0) ||
			account_status === "lead"
		) {
			const tattleProductKey = "15814865095e4391ada3222422565574";
			if (this.state.store_permission == 1) {
				return this.state.showMenu ? (
					<ul class="onclick-menu-content">
						{this.state.muvisixproductkey !== "" ? (
							<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
								<a>Log-In to Account</a>
							</li>
						) : (
							<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
								<a>Log-In to Account</a>
							</li>
						)}

						{this.state.muvisixproductkey !== "" && this.state.muvisixproductkey !== tattleProductKey ? (
							<li
								onClick={() =>
									this.leadMovetoDemo(productkey, apptoken, true, useruid, uname, name, storeKey)
								}
							>
								<a>Move to Demo</a>
							</li>
						) : this.state.muvisixproductkey == "" ? (
							<li onClick={() => this.movetoDemo(studio_id, name, user_id)}>
								<a>Move to Demo</a>
							</li>
						) : (
							""
						)}
						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#extendfreetrial"
							>
								<a>Extend Free Trial</a>
							</li>
						) : (
							""
						)}

						{this.state.muvisixproductkey !== "" ? (
							<li
								onClick={() => this.setInvoiceDetails(useruid, company_name)}
								data-toggle="modal"
								data-target="#raiseInvoiceModal"
							>
								<a>Raise Custom Invoice</a>
							</li>
						) : (
							""
						)}
					</ul>
				) : (
					""
				);
			} else {
				return (
					<ul class="onclick-menu-content">
						{/* ER#75420 */}
						{this.state.is_general_user != 1 ? (
							this.state.muvisixproductkey !== "" ? (
								<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
									<a>Log-In to Account</a>
								</li>
							) : (
								<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
									<a>Log-In to Account</a>
								</li>
							)
						) : (
							""
						)}
					</ul>
				);
			}
		} else if (
			(is_subscribed == 1 && status == 1 && deleted == 0 && is_default == 0 && muvi_free == 0) ||
			account_status === "customer"
		) {
			if (this.state.store_permission == 1) {
				return this.state.showMenu ? (
					<ul class="onclick-menu-content">
						{this.state.muvisixproductkey !== "" ? (
							<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
								<a>Log-In to Account</a>
							</li>
						) : (
							<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
								<a>Log-In to Account</a>
							</li>
						)}

						{/* {this.state.muvisixproductkey !== '' ?
                            <li onClick={() => this.assignAccountManager(apptoken)} data-toggle="modal" data-target="#assignaccount"><a>{account_status === 'customer' ? 'Change Account Manager' : 'Assign Account Manager'}</a></li>
                            :
                            <li onClick={() => { this.setState({ show: true }) }}>
                                {this.getalertbox(account_manager, studio_id, mname, user_id, account_manager_name)} </li>} */}

						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#changePassword"
							>
								<a>Change Password</a>
							</li>
						) : (
							""
						)}

						{this.state.muvisixproductkey !== "" ? (
							<li
								onClick={() =>
									this.setInvoiceDetails(useruid, company_name, get_enterprise_api_gateway_url)
								}
								data-toggle="modal"
								data-target="#raiseInvoiceModal"
							>
								<a>Raise Custom Invoice</a>
							</li>
						) : (
							""
						)}

						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#cancelAccount"
							>
								<a>Cancel Account</a>
							</li>
						) : (
							""
						)}
					</ul>
				) : (
					""
				);
			} else {
				return (
					<ul class="onclick-menu-content">
						{this.state.is_general_user != 1 ? (
							this.state.muvisixproductkey !== "" ? (
								<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
									<a>Log-In to Account</a>
								</li>
							) : (
								<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
									<a>Log-In to Account</a>
								</li>
							)
						) : (
							""
						)}

						{this.state.muvisixproductkey !== "" ? (
							<li
								onClick={() =>
									this.setInvoiceDetails(useruid, company_name, get_enterprise_api_gateway_url)
								}
								data-toggle="modal"
								data-target="#raiseInvoiceModal"
							>
								<a>Raise Custom Invoice</a>
							</li>
						) : (
							""
						)}
					</ul>
				);
			}
		} else if (is_subscribed == 0 && status == 4 && deleted == 0 && is_default == 0) {
			if (this.state.store_permission == 1) {
				//ER#62799>>'log-in' CTA should be there for cancelled stores
				return this.state.showMenu ? (
					<ul class="onclick-menu-content">
						{this.state.muvisixproductkey !== "" ? (
							<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
								<a>Log-In to Account</a>
							</li>
						) : (
							<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
								<a>Log-In to Account</a>
							</li>
						)}
						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#extendfreetrial"
							>
								<a>Restore</a>
							</li>
						) : (
							""
						)}
						{this.state.muvisixproductkey == "" ? (
							<li onClick={() => this.delete_studio(studio_id, name, user_id)}>
								<a>Delete</a>
							</li>
						) : (
							""
						)}
						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#subscriptionlink"
							>
								<a>Subscription Link</a>
							</li>
						) : (
							""
						)}
					</ul>
				) : (
					""
				);
			} else {
				return (
					<ul class="onclick-menu-content">
						{this.state.is_general_user != 1 ? (
							this.state.muvisixproductkey !== "" ? (
								<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
									<a>Log-In to Account</a>
								</li>
							) : (
								<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
									<a>Log-In to Account</a>
								</li>
							)
						) : (
							""
						)}
						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#subscriptionlink"
							>
								<a>Subscription Link</a>
							</li>
						) : (
							""
						)}
					</ul>
				);
			}
		} else if (is_subscribed == 0 && status == 0 && deleted == 1 && is_default == 0) {
			return this.state.showMenu ? (
				<ul class="onclick-menu-content">
					<li
						onClick={() => this.customer_details(studio_id, studio_name, user_id)}
						data-toggle="modal"
						data-target="#subscriptionlink"
					>
						<a>Subscription Link</a>
					</li>
				</ul>
			) : (
				""
			);
		} else if ((status == 1 && is_default == 1) || account_status === "demo") {
			if (this.state.store_permission == 1) {
				const tattleProductKey = "15814865095e4391ada3222422565574";
				return this.state.showMenu ? (
					<ul class="onclick-menu-content">
						{this.state.muvisixproductkey !== "" ? (
							<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
								<a>Log-In to Account</a>
							</li>
						) : (
							<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
								<a>Log-In to Account</a>
							</li>
						)}
						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#changePassword"
							>
								<a>Change Password</a>
							</li>
						) : (
							""
						)}
						{this.state.muvisixproductkey !== "" && this.state.muvisixproductkey !== tattleProductKey ? (
							<li
								onClick={() =>
									this.demoMovetoLead(productkey, apptoken, false, useruid, uname, name, storeKey)
								}
							>
								<a>Remove from Demo</a>
							</li>
						) : this.state.muvisixproductkey == "" ? (
							<li onClick={() => this.movefromDemo(studio_id, studio_name, user_id)}>
								<a>Remove from Demo</a>
							</li>
						) : (
							""
						)}
						{this.state.muvisixproductkey == "" ? (
							<li
								onClick={() => this.customer_details(studio_id, studio_name, user_id)}
								data-toggle="modal"
								data-target="#cancelAccount"
							>
								<a>Cancel Account</a>
							</li>
						) : (
							""
						)}
					</ul>
				) : null;
			} else {
				return (
					<ul class="onclick-menu-content">
						{this.state.is_general_user != 1 ? (
							this.state.muvisixproductkey !== "" ? (
								<li onClick={() => this.userDataEncrypt(productkey, useruid, name)}>
									<a>Log-In to Account</a>
								</li>
							) : (
								<li onClick={() => this.goToCustomerStore(email, encrypted_password, studio_id, name)}>
									<a>Log-In to Account</a>
								</li>
							)
						) : (
							""
						)}
					</ul>
				);
			}
		}
	}

	closeModalAssignAccountManager = () => {
		this.setState({
			popup: false,
			accountName: "",
		});
	};

	getalertbox(account_manager, studio_id, name, user_id, account_manager_name) {
		return (
			<div>
				{/* {account_manager != 0 ? <a href="javascript:void(0);" onClick={() => this.customer_details(studio_id, name, user_id)} data-toggle="modal" data-target="#changeaccountmanagername">Change Account Manager</a>
                    : <a href="javascript:void(0);" onClick={() => this.customer_details(studio_id, name, user_id)} data-toggle="modal" data-target="#changeaccountmanagername">Assign Account Manager</a>} */}
			</div>
		);
	}

	SaveAccountManagerMuvi5(studio_id, user_id, id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/saveAccountManager/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/account_id/" +
				id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				this.setState({});
				window.location.href = "/allStores/";
			});
	}

	demoMovetoLead = async (productKey, appToken, moveToDemo, userId, username, name, storeKey) => {
		if (window.confirm("Are you sure you want to move '" + name + "' account to demo studio?")) {
			fetch("https://apigateway.muvi.com/accounts/manage-demo-account", {
				method: "POST",
				headers: {
					"content-type": "application/json",
				},
				body: JSON.stringify({
					product_key: productKey,
					app_token: appToken,
					is_demo: moveToDemo,
					user_uuid: userId,
					store_key: storeKey ? storeKey : "",
				}),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.fetchProductByKey(productKey);
				});
		}
	};

	fetchProductByKey = (key) => {
		this.setState(
			{
				Loading: 1,
			},
			() => {
				fetch("https://apigateway.muvi.com/customer-list", {
					method: "POST",
					dataType: "json",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						query: `{getCustomerList( product_key: "${key}", type: \"All\", page: 0, size: 20) {page_info{total_count}, user_details {username, name, email, company_name,account_status,country_name, product_name, user_uuid, user_status, app_token, created_date, onhold_period, canceled_date, cancellation_reason, canceled_by,package_name, package_summary,  plan_name, source, store_key, is_enterprise , enterprise_api_gateway_url}}}`,
					}),
				})
					.then((Response) => Response.json())
					.then((findresponse) => {
						this.setState({
							Loading: 0,
							customers: findresponse.data.getCustomerList.user_details,
							item_count: findresponse.data.getCustomerList.page_info.total_count,
						});
					});
				this.setState({
					muvisixproductkey: key,
				});
			}
		);
	};
	movefromDemo(studio_id, studio_name, user_id) {
		if (window.confirm("Are you sure you want to remove '" + studio_name + "' account from demo studio?")) {
			fetch(
				this.state.apiUrl +
					"/adminRest/movefromDemo/id/" +
					studio_id +
					"/userAuthKey/" +
					this.state.userAuthKey,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					if (findresponse.code == 200) {
						this.setState({ message: findresponse.msg, show: false });
					} else {
						this.setState({ message: findresponse.msg });
					}
					this.getCustomers();
					this.setState({});
				});
		}
	}
	assignAccountManager = (apptoken) => {
		this.setState({
			popup: !false,
			customerAppToken: apptoken,
		});
	};
	selectAccountManager = (evt) => {
		evt.preventDefault();
		const { options, value } = evt.target;
		const data = {
			managerName: evt.target.accountValue.value,
			customerApptoken: this.state.customerAppToken,
			empName: this.state.accountName,
			productKey: this.state.muvisixproductkey,
			activePage: this.state.activePage,
		};
		this.assignMuvi6AccountManager(data);
		this.setState({ popup: false, accountName: "" });
	};
	assignMuvi6AccountManager(data) {
		fetch(this.state.apiUrl + "/adminRest/assignAccountManager/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((data) => {
				this.setState({
					mssg: "assign",
				});
				document.querySelector("body").classList.remove("modal-open");
				// this.getAllAccountManager();
			});
	}
	getAllAccountManager() {
		fetch(this.state.apiUrl + "/adminRest/getAllEmployee/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			dataType: "json",
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				this.setState({
					allEmployee: findresponse,
				});
			});
	}
	setAccountManagerName = (evt) => {
		this.setState({ accountName: evt.target.options[evt.target.selectedIndex].text });
	};

	loadMore(pageNumber) {
		this.setState({ isLoadMore: 0 });
		pageNumber = pageNumber + 1;
		this.setState({ activePage: pageNumber });
		fetch(
			this.state.apiUrl +
				"/adminRest/GetallStores/page/" +
				pageNumber +
				"/userId/" +
				this.state.userId +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.customers.length == 0) {
					this.setState({
						isLoadMore: 2,
					});
				} else {
					this.setState({
						isLoadMore: 1,
					});
				}
				this.setState({
					//isLoadMore:1,
					customers: this.state.customers.concat(findresponse.customers),
					//item_count: findresponse.item_count,
				});
			});
	}

	getMuviClassicCount(type = "") {
		const customer_type = { type: type };
		fetch("https://cms.muvi.com/intranet/getMuvi5TotalCounts", {
			method: "POST",
			body: JSON.stringify(customer_type),
		})
			.then((Response) => Response.json())
			.then((data) => {
				this.setState({
					muviFiveCount: data.total_count,
				});
			});
	}

	componentDidMount() {
		//        this.getCustomers();
		this.getMuviClassicCount(6);
		var muvi_one_prod_key = { target: "3D28C83C85544F0D9517DD2E7C7EEDAA" };
		const muvi_one_product_key = Object.assign({}, muvi_one_prod_key);
		this.getMuvisixCustomer(muvi_one_product_key, 1);

		document.title = "Intranet | AllStores";
		if (!localStorage.getItem("userLogin")) {
			this.setState({ redirect: true });
		}
		this.getAllAccountManager();
		$(document).ready(function () {
			document.getElementById("copyButton").addEventListener("click", copy, true);
			// event handler
			function copy(e) {
				// find target element
				var t = e.target,
					c = t.dataset.copytarget,
					inp = c ? document.querySelector(c) : null;
				// is element selectable?
				if (inp && inp.select) {
					// select text
					inp.select();
					try {
						// copy text
						document.execCommand("copy");
						inp.blur();
						// copied animation
						t.classList.add("copied");
						setTimeout(function () {
							t.classList.remove("copied");
						}, 1500);
					} catch (err) {
						alert("please press Ctrl/Cmd+C to copy");
					}
				}
			}
		});

		if (this.props.muvisixproductkey !== "") {
			const customer_section = { customer_section: 1 };
			fetch(this.state.apiUrl + "/RevenueRest/activeProductStatistics/userAuthKey/" + this.state.userAuthKey, {
				method: "POST",
				body: JSON.stringify(customer_section),
			})
				.then((Response) => Response.json())
				.then((data) => {
					this.setState({
						allmuvisix: data.data,
					});
					let dat = [...this.state.allmuvisix];
					let now = [];

					dat.forEach(({ product_key, product_name, customers, leads, cancelled, deleted, demo }) => {
						//now[product_name] = customers + leads + cancelled + deleted + demo
						now.push({
							product_key: product_key,
							product_name: product_name,
							total: customers + leads + cancelled + deleted + demo,
						});
					});
					this.setState({ muviCountAll: now });
				});
		}
	}
	loadMorecount() {
		if (this.state.item_count > 0) {
			if (this.state.item_count >= 20) {
				if (this.state.isLoadMore != 2) {
					if (this.state.isLoadMore == 1) {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="load_more" onClick={() => this.loadMore(this.state.activePage)}>
									<span></span>
									<span></span>
									<span></span>
								</div>
							</div>
						);
					} else {
						return (
							<div class="pagination-muvi" id="section07">
								<div class="lds-ripple">
									<div></div>
									<div></div>
								</div>
							</div>
						);
					}
				}
			}
		} else {
			return <div className="text-center">No Data Found</div>;
		}
	}

	muviSixpagination = () => {
		if (20 * (this.state.activePage - 1 + 1) > this.state.item_count) {
			return (
				20 * (this.state.activePage - 1) + 1 + " - " + this.state.item_count + " of " + this.state.item_count
			);
		} else {
			return (
				20 * (this.state.activePage - 1) +
				1 +
				" - " +
				20 * (this.state.activePage - 1 + 1) +
				" of " +
				this.state.item_count
			);
		}
	};

	menuHideShow = () => {
		this.setState({
			showMenu: !false,
		});
	};

	getAllStoreList() {
		let hideSearchforMuvisix = "";
		hideSearchforMuvisix = (
			<div class="searchTicket mob_customer">
				<input
					type="text"
					class="form-control"
					name="customer"
					id="customer"
					value={this.state.search}
					placeholder="Search company, name or email"
					onChange={this.keywordChange}
				/>
				<button type="submit">
					<i class="fa fa-search"></i>
				</button>
			</div>
		);

		return (
			<section class="customer">
				<div id="exTab1" class="container">
					<CustomerTabMenu brecum_page="alllist" />

					<div class="tab-content clearfix">
						<div class="tab-pane active" id="Onboarding">
							<div class="row">
								<div class="col-md-5">
									<div class="row">
										<div class="col-md-7">
											<select
												className="form-control"
												value={this.muvisixproductkey}
												onChange={this.getMuvisixCustomer}
											>
												{this.state.muviCountAll.map((item, index) => {
													return item.product_key != "49F37046FCD84520895FC18A4F5BFC8B" ? (
														item.product_key == "3D28C83C85544F0D9517DD2E7C7EEDAA" ? (
															<option value={item.product_key} key={index} selected>
																{item.product_name} ({item.total})
															</option>
														) : (
															<option value={item.product_key} key={index}>
																{item.product_name} ({item.total})
															</option>
														)
													) : (
														<option value="">
															Muvi One (Classic) ({this.state.muviFiveCount})
														</option>
													);
												})}
											</select>
										</div>
										{this.state.isMuviLive ? (
											<div className="col-md-5">
												<button
													onClick={() =>
														this.getLiveStreamBtn(this.state.selected_product_key)
													}
													className="btn btn-info"
												>
													Stream Info
												</button>
											</div>
										) : (
											""
										)}
									</div>
								</div>

								<div class="col-md-1"></div>

								<div class="col-md-6">{hideSearchforMuvisix}</div>
							</div>
							{this.state.isStremInfo ? (
								this.liveStreamList()
							) : (
								<div class="list_check">
									<div class="tickets hidden-sm">
										<ul class="tickets_head">
											<li
												class={
													this.state.muvisixproductkey !== ""
														? "intra_col_10"
														: "intra_col_15"
												}
											>
												Company
											</li>
											<li
												class={
													this.state.muvisixproductkey !== ""
														? "intra_col_10"
														: "intra_col_10"
												}
											>
												Name
											</li>
											<li
												class={
													this.state.muvisixproductkey !== ""
														? "intra_col_15"
														: "intra_col_10"
												}
											>
												Email
											</li>
											{this.state.muvisixproductkey === "" || this.state.isMuviOne ? (
												<li
													class={
														this.state.muvisixproductkey != ""
															? "intra_col_10"
															: "intra_col_15"
													}
												>
													Website
												</li>
											) : (
												""
											)}
											<li
												class={
													this.state.muvisixproductkey != "" ? "intra_col_10" : "intra_col_10"
												}
											>
												Country
											</li>
											{this.state.muvisixproductkey == "" ? (
												<li class="intra_col_10">Type</li>
											) : (
												""
											)}
											{this.state.muvisixproductkey != "" ? (
												<li
													class={
														this.state.muvisixproductkey != ""
															? "intra_col_10"
															: "intra_col_10"
													}
												>
													Type
												</li>
											) : (
												""
											)}
											<li
												class={
													this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_15"
												}
											>
												Joined On
											</li>
											<li
												class={
													this.state.muvisixproductkey != "" ? "intra_col_15" : "intra_col_10"
												}
											>
												Source
											</li>
											<li class="intra_col_5"></li>
										</ul>
										{this.state.Loading ? (
											<div>
												<div class="loader-new"></div>
											</div>
										) : (
											this.state.customers.map((data, key) => (
												<ul class="tickets_number">
													<li
														class={
															this.state.muvisixproductkey != ""
																? "intra_col_10"
																: "intra_col_15"
														}
													>
														{this.state.muvisixproductkey == "" ? (
															<Link
																key={key}
																to={`/test/detail/${data.studio_id}`}
																name={"max"}
															>
																{" "}
																{data.company_name
																	? data.company_name
																	: data.name
																	? data.name
																	: "NA"}
															</Link>
														) : (
															<Link
																key={key}
																to={`/test/detail/${data.app_token}`}
																name={"max"}
															>
																{" "}
																{data.company_name
																	? data.company_name
																	: data.name
																	? data.name
																	: "NA"}
															</Link>
														)}{" "}
													</li>
													<li
														class={
															this.state.muvisixproductkey != ""
																? "intra_col_10"
																: "intra_col_10"
														}
													>
														{data.first_name
															? data.first_name
															: data.name
															? data.name
															: "NA"}
													</li>
													<li
														class={
															this.state.muvisixproductkey != ""
																? "intra_col_15"
																: "intra_col_10"
														}
													>
														{data.email ? data.email : "NA"}
													</li>
													{this.state.muvisixproductkey == "" || this.state.isMuviOne ? (
														<li
															class={
																this.state.muvisixproductkey != ""
																	? "intra_col_10 text-inded"
																	: "intra_col_15 text-inded"
															}
														>
															<a
																href={`http://${
																	data.domain ? data.domain : data.domain_name
																}`}
																target="_blank"
															>
																{data.domain ? data.domain : data.domain_name}
															</a>
														</li>
													) : (
														""
													)}
													<li
														class={
															this.state.muvisixproductkey != ""
																? "intra_col_10"
																: "intra_col_10"
														}
													>
														{data.country
															? data.country
															: data.country_name
															? data.country_name
															: "NA"}
													</li>
													{this.state.muvisixproductkey == "" ? (
														<li class="intra_col_10">
															<div>
																{this.gettype(
																	data.is_subscribed,
																	data.status,
																	data.is_deleted,
																	data.is_default,
																	data.muvi_free
																) === "Paying" ? (
																	<span style={{ color: "green" }}>Paying</span>
																) : (
																	<span>
																		{this.gettype(
																			data.is_subscribed,
																			data.status,
																			data.is_deleted,
																			data.is_default,
																			data.muvi_free
																		)}
																	</span>
																)}
															</div>
														</li>
													) : (
														""
													)}

													{this.state.muvisixproductkey != "" ? (
														<li
															class={
																this.state.muvisixproductkey != ""
																	? "intra_col_10"
																	: "intra_col_10"
															}
														>
															{data.account_status
																? data.account_status
																: data.account_status
																? data.account_status
																: "NA"}
														</li>
													) : (
														""
													)}

													<li
														class={
															this.state.muvisixproductkey != ""
																? "intra_col_15"
																: "intra_col_15"
														}
													>
														{data.created_at_change
															? new Date(data.created_at_change).toLocaleDateString(
																	"en-US",
																	{ month: "short", day: "numeric", year: "numeric" }
															  )
															: new Date(data.created_date).toLocaleDateString("en-US", {
																	month: "short",
																	day: "numeric",
																	year: "numeric",
															  })}
													</li>
													<li
														class={
															this.state.muvisixproductkey != ""
																? "intra_col_15 text-inded"
																: "intra_col_10 text-inded"
														}
													>
														{data.source ? this.getSourceLink(data.source) : "NA"}
													</li>

													<li
														onClick={this.menuHideShow}
														style={{ position: "relative" }}
														className="intra_col_5"
													>
														<div tabindex="0" class="onclick-menu c-details pull-right">
															{this.state.muvisixproductkey == ""
																? this.getMuvi5TypeStatus(
																		this.gettype(
																			data.is_subscribed,
																			data.status,
																			data.is_deleted,
																			data.is_default,
																			data.muvi_free
																		)
																  )
																: this.getMuvi6TypeStatus(data.account_status)}

															{this.getCustomersMenu(
																data.studio_id,
																data.first_name,
																data.user_id,
																data.email,
																data.encrypted_password,
																data.name,
																data.is_subscribed,
																data.status,
																data.is_deleted,
																data.is_default,
																data.account_manager,
																data.company_name,
																data.account_status,
																data.store_key,
																this.state.muvisixproductkey,
																data.app_token,
																false,
																data.user_uuid,
																data.username,
																data.muvi_free,
																data.is_enterprise,
																data.enterprise_api_gateway_url
															)}
														</div>
													</li>
												</ul>
											))
										)}
									</div>
								</div>
							)}
							<div class="customer_mob hidden-md">
								{this.state.customers.map((data, key) => (
									<div class="custmer_list_mob">
										<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
											<h4 class="list_title">{data.first_name}</h4>
										</Link>
										<Link key={key} to={`/test/detail/${data.studio_id}`} name={"max"}>
											<div class="wrap">{data.domain}</div>
										</Link>
										<div tabindex="0" class="onclick-menu pull-right">
											{this.getCustomersMenu(
												data.studio_id,
												data.first_name,
												data.user_id,
												data.email,
												data.encrypted_password,
												data.name,
												data.is_subscribed,
												data.status,
												data.is_deleted,
												data.is_default,
												data.account_manager,
												data.company_name,
												data.account_status,
												data.store_key
											)}
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
					{this.state.Loading ? (
						""
					) : !this.state.isStremInfo ? (
						<span>
							{this.state.item_count > 0 ? (
								<div class="pagination-muvi">
									<Pagination
										itemClass={"pages"}
										itemClassFirst={"first_page"}
										itemClassPrev={"prev_page"}
										itemClassNext={"next_page"}
										itemClassLast={"last_page"}
										activePage={this.state.activePage}
										itemsCountPerPage={20}
										totalItemsCount={this.state.item_count}
										pageRangeDisplayed={5}
										onChange={this.state.setPage == "yes" ? this.handlePageChange : ""}
									/>
									<div style={{ color: "#333" }}>
										{this.state.muvisixproductkey == ""
											? this.state.offset +
											  1 +
											  " - " +
											  (this.state.offset + this.state.off_count) +
											  " of " +
											  this.state.item_count
											: this.muviSixpagination()}
									</div>
								</div>
							) : (
								<div className="text-center" style={{ color: "#333" }}>
									No Data Found
								</div>
							)}
						</span>
					) : (
						""
					)}
					{/* {this.loadMorecount()} */}
				</div>
			</section>
		);
	}
	managerChange(propertyName, event) {
		const id = this.state.id;
		id[propertyName] = event.target.value;
		this.setState({ id: id });
	}
	Savepasswordmuvi5(studio_id, user_id, new_password) {
		this.Savepassword(studio_id, user_id, new_password);
	}
	setInvoiceDetails(userid, companyname, enterprise_api_gateway_url = "") {
		this.flag = 0;
		this.setState({
			message: "",
			userid: userid,
			customer_name_muvi6: companyname,
			item_name: "",
			item_description: "",
			invoice_amount: "",
			enterprise_api_gateway_url: enterprise_api_gateway_url,
		});
		document.getElementById("raiseInvoiceModal").style.display = "block";
	}

	submitInvoice() {
		this.flag = 0;
		if (this.handleValidation()) {
		} else {
			return false;
		}
		document.getElementById("submit_invoice").innerHTML = "Sending....";
		document.getElementById("submit_invoice").disabled = true;
		this.raiseInvoice(
			this.state.item_name,
			this.state.item_description,
			this.state.invoice_amount,
			this.state.muvisixproductkey,
			this.state.userid,
			this.state.activePage - 1,
			this.state.enterprise_api_gateway_url
		);
		setTimeout(() => {
			this.flag = 1;
		}, 3000);
	}
	raiseInvoice(
		item_name,
		item_description,
		invoice_amount,
		productkey,
		userid,
		activePage,
		enterprise_api_gateway_url
	) {
		const loginDetails = {
			product_key: `${productkey}`,
			user_uuid: `${userid}`,
			muvi_user_uuid: "17325ad1c482fa796bfbea34d7157",
			item_name: `${item_name}`,
			item_description: `${item_description}`,
			invoice_amount: `${invoice_amount}`,
			enterprise_api_gateway_url: `${enterprise_api_gateway_url}`,
		};
		fetch(this.state.apiUrl + "/adminRest/raiseCustomInvoice/userAuthKey/" + this.state.userAuthKey, {
			method: "POST",
			//            headers: {
			//                'content-type': 'application/json'
			//            },
			dataType: "json",
			body: JSON.stringify(loginDetails),
		})
			.then((Response) => Response.json())
			.then((data) => {
				if (data.code == 200) {
					this.setState(
						{
							code: data.code,
							message: data.message,
						},
						function () {
							window.location.href = "/allStores";
						}
					);
				} else {
					this.setState({
						message: data.message,
					});
				}
				document.getElementById("submit_invoice").innerHTML = "Submit Invoice";
				document.getElementById("submit_invoice").disabled = false;
			});
	}

	isValidNumber(number) {
		var pattern = /^[0-9]*\.?[0-9]*$/;
		return pattern.test(number);
	}

	handleValidation() {
		let errors = {};
		let formIsValid = true;
		if (!this.state.item_name) {
			formIsValid = false;
			errors["item_name"] = "This field is required.";
		}
		if (!this.state.item_description) {
			formIsValid = false;
			errors["item_description"] = "This field is required.";
		}
		if (!this.state.invoice_amount) {
			formIsValid = false;
			errors["invoice_amount"] = "This field is required.";
		}
		if (this.state.invoice_amount && !this.isValidNumber(this.state.invoice_amount)) {
			formIsValid = false;
			errors["invoice_amount"] = "Invalid Amount";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}

	CancelAccount(studio_id, user_id, custom_notes = "", is_charged = "") {
		fetch(
			this.state.apiUrl +
				"/AdminRest/CancelAccountForCustomers/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/custom_notes/" +
				custom_notes +
				"/is_charged/" +
				is_charged +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.rawjsonparse(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({ message: findresponse.msg }, function () {
						window.location.href = "/allStores";
					});
				} else {
					this.setState({ message: findresponse.msg });
				}
			});
	}
	handleChangeStart(date) {
		this.setState({
			startDate: Date.parse(date),
			start_date: moment(date).format("YYYY-MM-DD"),
		});
	}
	ExtendTrialPeriod(studio_id) {
		if (window.confirm("Are you sure you want to extend trial period?")) {
			fetch(
				this.state.apiUrl +
					"/AdminRest/ExtendTrialPeriod/studio_id/" +
					studio_id +
					"/start_date/" +
					this.state.start_date +
					"/userAuthKey/" +
					this.state.userAuthKey,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					findresponse = this.rawjsonparse(findresponse, 1);
					if (findresponse.code == 200) {
						this.setState({ message1: findresponse.msg }, function () {
							window.location.href = "/allStores";
						});
					} else {
						this.setState({ message1: findresponse.msg });
					}
				});
		}
	}
	delete_studio(studio_id, studio_name, user_id) {
		if (window.confirm("Are you sure you want to delete account '" + studio_name + "'")) {
			fetch(
				this.state.apiUrl +
					"/AdminRest/DeleteAccount/studio_id/" +
					studio_id +
					"/user_id/" +
					user_id +
					"/userAuthKey/" +
					this.state.userAuthKey,
				{
					method: "POST",
					dataType: "json",
					body: JSON.stringify(this.state),
				}
			)
				.then((Response) => Response.json())
				.then((findresponse) => {
					window.location.href = "/allStores";
				});
		}
	}
	restoreStudio(studio_id, user_id) {
		fetch(
			this.state.apiUrl +
				"/AdminRest/Restore/studio_id/" +
				studio_id +
				"/user_id/" +
				user_id +
				"/userAuthKey/" +
				this.state.userAuthKey,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
			.then((Response) => Response.json())
			.then((findresponse) => {
				window.location.href = "/allStores";
			});
	}

	render() {
		if (this.state.redirect) {
			return <Redirect to={"/login"} />;
		}
		return (
			<div>
				<div class="modal fade" id="extendfreetrial" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Extend Free Trial
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Company</b>
								</label>
								<input
									type="text"
									name="company"
									value={this.state.studio_id.name}
									className="form-control"
									readOnly
								/>

								<label>
									<b>Date</b>
								</label>

								<DatePicker
									selected={this.state.startDate}
									selectsStart
									startDate={this.state.startDate}
									onChange={this.handleChangeStart}
									minDate={this.state.minDate}
									dateFormat="dd-MM-yyyy"
									peekNextMonth
									showMonthDropdown
									showYearDropdown
									dropdownMode="select"
									onKeyDown={(e) => e.preventDefault()}
								/>

								<span style={{ color: "red" }}>{this.state.message1}</span>
								<br />
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									onClick={() =>
										this.ExtendTrialPeriod(this.state.studio_id.id, this.state.user_id.id)
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for FreeTrial-!> */}
				{/* <--raise invoice for muvi 6-!> */}
				<div class="modal fade" id="raiseInvoiceModal" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Raise Invoice
								</h4>
							</div>
							<div class="modal-body">
								<div class="form-group">
									<label class="span2 control-label" for="company" style={{ fontSize: "20px" }}>
										{this.state.customer_name_muvi6}
									</label>
								</div>
								Title
								<input
									type="text"
									class="form-control"
									name="item_name"
									value={this.state.item_name}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["item_name"]}</span>
								<br></br>
								Description
								<input
									type="text"
									class="form-control"
									name="item_description"
									value={this.state.item_description}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["item_description"]}</span>
								<br></br>
								Amount($)
								<input
									type="text"
									class="form-control"
									name="invoice_amount"
									value={this.state.invoice_amount}
									onKeyPress={this.spaceKeyPress}
									onChange={this.onChange}
									placeholder=""
								/>
								<span class="error">{this.state.errors["invoice_amount"]}</span>
								<br></br>
							</div>
							<span style={{ color: "red" }}>
								{this.props.message && this.flag == 1 ? this.props.message : ""}
							</span>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									name="submit_invoice"
									id="submit_invoice"
									class="btn btn-sky"
									onClick={() => this.submitInvoice()}
								>
									Submit Invoice
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for -!> */}

				{/* <--modal start for change Password-!> */}
				<div class="modal fade" id="changePassword" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Update Password
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>New Password</b>
								</label>
								<input
									type="text"
									name="new_password"
									id="new_password"
									className="form-control"
									onChange={this.onChange}
								/>
								<span style={{ color: "red" }}>{this.state.message}</span>
								<input type="hidden" value={this.state.studio_id_id} name="studio_id" />
								<input type="hidden" value={this.state.user_id_id} name="user_id" />
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									onClick={() =>
										this.Savepasswordmuvi5(
											this.state.studio_id_id,
											this.state.user_id_id,
											this.state.new_password
										)
									}
								>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for change Password-!> */}

				{/* <--modal end for change Account Manager Name If Exists-!> */}
				{/* <--modal start for change Account manager for muviv5-!> */}

				<div class="modal fade" id="changeaccountmanagername" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Set Account Manager
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Account Manager</b>
								</label>
								<select
									class="form-control"
									id="id"
									name="id"
									value={this.state.customers.user_id}
									onChange={
										this.state.customers.user_id
											? this.managerChange.bind(this, "id")
											: this.onChange
									}
								>
									<option value="0">-Select-</option>
									{this.state.account_manager.map((account_manager, key) => (
										<option value={account_manager.id}>{account_manager.name}</option>
									))}
								</select>
								<input type="hidden" value={this.state.customers.studio_id} name="studio_id" />
								<input type="hidden" value={this.state.customers.user_id} name="user_id" />
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-sky" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-blue"
									data-dismiss="modal"
									onClick={() =>
										this.SaveAccountManagerMuvi5(
											this.state.customers.studio_id,
											this.state.customers.user_id,
											this.state.customers.id
										)
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				{this.state.popup ? (
					<div
						className={`modal fade ${this.state.popup ? "show" : ""}`}
						id="assignaccount"
						role="dialog"
						style={this.state.popup ? { opacity: "1", marginTop: "10px" } : ""}
					>
						<div class="modal-dialog modal-md">
							<div class="modal-content" style={this.state.popup ? { marginTop: "65px" } : ""}>
								<div class="modal-header">
									<button
										type="button"
										class="close"
										data-dismiss="modal"
										onClick={() => this.setState({ popup: !true })}
									>
										&times;
									</button>
									<h4 style={{ color: "black" }} class="modal-title">
										Set Account Manager
									</h4>
								</div>
								<div class="modal-body text-center">
									<form onSubmit={(evt) => this.selectAccountManager(evt)}>
										<div className="form-group">
											<select
												name="accountValue"
												className="form-control"
												onChange={(evt) => this.setAccountManagerName(evt)}
											>
												<option value="">Select Account Manager</option>
												{this.state.allEmployee.map((data) => {
													return <option value={data.id}>{data.name}</option>;
												})}
											</select>
										</div>
										<div className="form-group float-left">
											<button
												type="button"
												class="btn btn-sky"
												data-dismiss="modal"
												onClick={this.closeModalAssignAccountManager}
											>
												Cancel
											</button>
											<button type="submit" className="btn btn-primary">
												Submit
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				) : (
					""
				)}
				<div class="modal fade" id="cancelAccount" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Cancel Account
								</h4>
							</div>
							<div class="modal-body">
								<label>
									<b>Company</b>
								</label>
								<input
									type="text"
									name="company"
									value={this.state.studio_id_name}
									className="form-control"
									onChange={this.onChange}
									readOnly
								/>
								<input
									type="hidden"
									value={this.state.studio_id_id}
									name="studio_id"
									onChange={this.onChange}
								/>
								<input
									type="hidden"
									value={this.state.user_id_id}
									name="user_id"
									onChange={this.onChange}
								/>
								<br />
								<label>
									<b>Reason</b>
								</label>
								<textarea
									style={{ resize: "none" }}
									class="form-control"
									name="custom_notes"
									id="custom_notes"
									required
									onChange={this.onChange}
								></textarea>
								<span style={{ color: "red" }}> {this.state.message1}</span>
								<br />
								<label>
									<b>Do you want to charge this customer?</b>
								</label>
								<div class="radio feature-check">
									<input
										class="valid_fld"
										id="3"
										type="radio"
										name="is_charged"
										value="1"
										onChange={this.onChange}
									/>
									<label for="3">
										<span></span>
										Yes
									</label>
								</div>
								<div class="radio feature-check">
									<input
										class="valid_fld"
										id="4"
										type="radio"
										name="is_charged"
										value="0"
										onChange={this.onChange}
									/>
									<label for="4">
										<span></span>
										No
									</label>
								</div>
								<span style={{ color: "red" }}>{this.state.message1}</span>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">
									Cancel
								</button>
								<button
									type="button"
									class="btn btn-sky"
									onClick={() =>
										this.CancelAccount(
											this.state.studio_id_id,
											this.state.user_id_id,
											this.state.custom_notes,
											this.state.is_charged
										)
									}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>

				{/* <--modal start for subscription link-!> */}
				<div class="modal fade" id="subscriptionlink" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">
									&times;
								</button>
								<h4 style={{ color: "black" }} class="modal-title">
									Copy Subscription Link
								</h4>
							</div>
							<div class="modal-body">
								<input
									type="text"
									name="subscription_link"
									id="subscription_link"
									className="form-control"
									value={
										"https://www.muvi.com/signup/purchaseSubscription.html?studio=" +
										this.state.studio_id.uniqid
									}
									onChange={this.onChange}
								/>
								<input type="hidden" value={this.state.studio_id.id} name="studio_id" />
								<input type="hidden" value={this.state.user_id.id} name="user_id" />
								<br />
								<button
									type="button"
									id="copyButton"
									data-copytarget="#subscription_link"
									class="btn btn-default"
								>
									Copy
								</button>
							</div>

							<div class="modal-footer">
								<button type="button" class="btn btn-default" data-dismiss="modal">
									Cancel
								</button>
								{/* <button type="button" class="btn btn-default" onClick={()=> this.Savepassword(this.state.studio_id.id, this.state.user_id.id)}>Update</button> */}
							</div>
						</div>
					</div>
				</div>
				{/* <--modal end for subscription link-!> */}
				<Header brecum_name="Customer" brecum_page="All" />
				<div className="right_col">{this.getAllStoreList()}</div>
			</div>
		);
	}
}

export default CustomerList;



// WEBPACK FOOTER //
// ./src/components/customer/AllStoreList.js